export default __webpack_public_path__ + "static/img7-e65bf67a48968ed8fcedaea5248cadb0.jpg";